import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  buttons: {
    paddingTop: theme.spacing(4),
    [theme.breakpoints.down('lg')]: {
      paddingTop: theme.spacing(3),
    },
    [theme.breakpoints.down('md')]: {
      paddingLeft: 0,
      '& #accept-button': {
        height: 44,
        width: 204,
      },
    },
  },
}));
